import axios from 'axios';
import { WORK, TIMELINE, LOADING_UI, CLEAR_ERRORS, SET_ERRORS, ONEWORK } from '../types';

import worksData from '../../data/works.json';
import timelineData from '../../data/timeline.json';
import images from '../../images';

export const getWorks = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    try {
        const mapped = worksData.map(w => ({ ...w, image: images[w.image] || w.image }));
        dispatch({
            type: WORK,
            payload: mapped
        });
    } catch (err) {
        console.log('Error loading local works:', err);
    }
};

export const getWorkByTitle = (data) => (dispatch) => {
    try {
        const found = worksData.find(w => w.title === data);
        if (found) {
            const mapped = { ...found, image: images[found.image] || found.image };
            dispatch({
                type: ONEWORK,
                payload: mapped
            });
        } else {
            dispatch({
                type: ONEWORK,
                payload: null
            });
        }
    } catch (err) {
        console.log('Error loading local work:', err);
    }
}

export const getTimeline = () => (dispatch) => {
    try {
        const mapped = timelineData;
        dispatch({
            type: TIMELINE,
            payload: mapped
        });
    } catch (err) {
        console.log('Error loading local timeline:', err);
    }
};

export const sendRequest = (data, history) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios.post('/contact', data)
            .then( res => {
                console.log(res.data);
                dispatch({ type: CLEAR_ERRORS });
                history.push('/');
            })
            .catch(err => {
                dispatch({
                    type: SET_ERRORS,
                    payload: err.response.data
                });
            });
};